import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Paths } from "./../../constants/UrlConstants";
import { connect } from "react-redux";
import Store from "./../../content/Store";
import Contentify from "../../content/Contentify";
import linkStyles from "../../assets/css/modules/shared/link.css";

export class InboxStatus extends Component {
  static content = Store.InboxStatus;

  render() {
    const noMessages = `${this.props.content.no} ${this.props.content.zeronewMessages}`;
    const unreadMessages = `${this.props.unreadMessageCount} ${this.props.unreadMessageCount === 1 ?this.props.content.newMessages:this.props.content.morethanewMessages}`;
    return (
      <React.Fragment>
        <i className="icon-email" />
        <span className="ml-2">
          {(this.props.unreadMessageCount === null || this.props.unreadMessageCount === undefined || this.props.unreadMessageCount === 0) ?this.props.content.youHaveReceived:''}
          {"  "}
           {this.props.unreadMessageCount ? 
           this.props.IsInternalView?
             (<Link to="/" className={linkStyles.disabled} onClick={ (event) => event.preventDefault() }>
              {this.props.content.youHaveReceived} {unreadMessages}</Link>)
              :
            (
            <Link id="unreadMessageCount" to={Paths.InboxLoader}>
              {this.props.content.youHaveReceived} {unreadMessages}
            </Link>
            ) : (
            noMessages
          )}  
        </span> 
      </React.Fragment>
    );
  }
}

export const mapStateToInboxStatus = ({ unreadMessagesReducer, policyReducer }) => {
  return {
    unreadMessageCount:unreadMessagesReducer.unreadMessageCount,
    IsInternalView: policyReducer &&
    policyReducer.policyDetails &&
    policyReducer.policyDetails.IsInternalView,
  };
};

export default connect(mapStateToInboxStatus)(Contentify(InboxStatus));
